module.exports = __webpack_public_path__ + "img/prop-2.2eb48ca0.svg";